import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { NativeTeamContextService } from '../../services/native-team-context/native-team-context.service';
import { PayrollAccessService } from '../../services/payroll-access/payroll-access.service';
import { TeamsService } from '../../services/teams/teams.service';

@Injectable({
  providedIn: 'root',
})
export class WellspaceContextGuard {
  constructor(
    private teamsService: TeamsService,
    private nativeTeamContextService: NativeTeamContextService,
    private payrollAccessService: PayrollAccessService,
    private router: Router,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    const nativeTeamState = await this.nativeTeamContextService.initialize();
    if (
      this.payrollAccessService.workspaceContext === 'nativeCompanyManager'
      && !nativeTeamState.active
    ) {
      return this.router.parseUrl('/');
    }
    const wellspace = await this.teamsService.ensureValidatedSelectedWellspace();
    return wellspace ? true : this.router.parseUrl('/');
  }
}
